import React, { useState, useEffect } from "react";
import axios from "axios";
import Cookies from "js-cookie";
import { loadRazorpay } from "../../../Utils/razorpay";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
	FiHome,
	FiUser,
	FiMapPin,
	FiArrowLeft,
	FiPlus,
	FiCheck,
	FiPhone,
	FiCheckCircle
} from "react-icons/fi";
import { MdOutlineMail } from "react-icons/md";
import { useNavigate } from "react-router-dom";

const OrderSuccessModal = ({ order, onClose, onGoToOrders }) => (
	<div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
		<div className="bg-white rounded-xl shadow-xl max-w-md w-full px-6 py-8 text-center">
			<div className="flex flex-col items-center">
				<FiCheckCircle className="text-green-500 text-5xl mb-3" />
				<h2 className="text-2xl font-bold text-green-600 mb-2">Order Placed Successfully!</h2>
				<p className="text-gray-700 mb-2">Thank you for shopping with us. Your order has been placed and is being processed.</p>
				<div className="bg-gray-50 p-4 rounded-lg mb-4 w-full text-left mt-4">
					<h3 className="font-semibold mb-1">Order Details:</h3>
					<div className="text-sm text-gray-700">
						<div><span className="font-medium">Order ID:</span> {order?._id || "N/A"}</div>
						<div><span className="font-medium">Amount Paid:</span> ₹{order?.totalAmount?.toFixed(2) || "N/A"}</div>
						<div><span className="font-medium">Payment Mode:</span> {order?.payment?.method === "cod" ? "Cash on Delivery" : "Online"}</div>
						<div><span className="font-medium">Order Status:</span> {order?.status ? order.status.charAt(0).toUpperCase() + order.status.slice(1) : "Pending"}</div>
						{order?.shippingAddress && (
							<div className="mt-2">
								<span className="font-medium">Shipping To:</span> <br />
								<span className="text-gray-600">{[
									order.shippingAddress.fullName,
									order.shippingAddress.phone,
									order.shippingAddress.addressLine1,
									order.shippingAddress.addressLine2,
									`${order.shippingAddress.city}, ${order.shippingAddress.state} ${order.shippingAddress.zipCode}`,
									order.shippingAddress.country
								].filter(Boolean).join(", ")}</span>
							</div>
						)}
					</div>
				</div>
			</div>
			<div className="flex justify-center gap-3 mt-5">
				<button
					className="px-4 py-2 min-w-[120px] rounded-lg bg-blue-600 text-white font-medium hover:bg-blue-700 transition"
					onClick={onGoToOrders}
				>
					View Orders
				</button>
				<button
					className="px-4 py-2 min-w-[120px] rounded-lg bg-gray-200 text-gray-800 font-medium hover:bg-gray-300 transition"
					onClick={onClose}
				>
					Close
				</button>
			</div>
		</div>
	</div>
);

const ShippingAddress = ({
	onClose,
	onSubmit,
	orderSummary,
	cartItems,
	clearCart,
	fetchCart
}) => {
	const [formData, setFormData] = useState({
		fullName: "",
		phone: "",
		email: "",
		addressLine1: "",
		addressLine2: "",
		city: "",
		state: "",
		zipCode: "",
		country: "India",
		isDefault: false
	});
	const [paymentMethod, setPaymentMethod] = useState("cod");
	const [isSubmitting, setIsSubmitting] = useState(false);
	const [amount, setAmount] = useState(0);
	const [error, setError] = useState("");
	const [step, setStep] = useState(1);
	const [addresses, setAddresses] = useState([]);
	const [selectedAddressId, setSelectedAddressId] = useState("");
	const [showAddressForm, setShowAddressForm] = useState(false);
	const [isLoadingAddresses, setIsLoadingAddresses] = useState(true);
	const [checkoutSummary, setCheckoutSummary] = useState(null);
	const [isLoadingCheckout, setIsLoadingCheckout] = useState(false);

	const [orderSuccess, setOrderSuccess] = useState(false);
	const [placedOrder, setPlacedOrder] = useState(null);

	const { user } = useSelector(state => state.auth);
	const navigate = useNavigate();

	const fetchAddresses = async () => {
		const token = Cookies.get("ecom_user_token");
		setIsLoadingAddresses(true);
		try {
			const response = await axios.get(
				`${process.env.REACT_APP_BACKEND_URL}/api/buyer/get-shipping-addresses`,
				{
					headers: {
						Authorization: `Bearer ${token}`
					}
				}
			);
			const receivedAddresses = response.data?.shippingAddresses || [];
			const sortedAddresses = [...receivedAddresses].sort((a, b) => {
				if (a.isDefault !== b.isDefault) return b.isDefault ? 1 : -1;
				return new Date(b.createdAt) - new Date(a.createdAt);
			});
			setAddresses(sortedAddresses);
			const defaultAddress = sortedAddresses.find(addr => addr.isDefault) || sortedAddresses[0];
			if (defaultAddress) setSelectedAddressId(defaultAddress._id);
		} catch (err) {
			console.error("Error fetching addresses:", err);
			toast.error(err.response?.data?.msg || "Failed to load addresses");
			setAddresses([]);
		} finally {
			setIsLoadingAddresses(false);
		}
	};

	// const fetchCheckoutSummary = async (paymentMethodType = paymentMethod) => {
	// 	if (!selectedAddressId) {
	// 		setError("Please select a shipping address");
	// 		return;
	// 	}

	// 	setIsLoadingCheckout(true);
	// 	setError("");
	// 	const token = Cookies.get("ecom_user_token");

	// 	try {
	// 		const response = await axios.post(
	// 			`${process.env.REACT_APP_BACKEND_URL}/api/buyer/checkout-summary`,
	// 			{
	// 				shippingAddressId: selectedAddressId,
	// 				paymentMethod: {
	// 					type: paymentMethodType === "razorpay" ? "prepaid" : paymentMethodType
	// 				}
	// 			},
	// 			{
	// 				headers: {
	// 					Authorization: `Bearer ${token}`,
	// 					"Content-Type": "application/json"
	// 				}
	// 			}
	// 		);

	// 		if (response.data.success) {
	// 			setCheckoutSummary(response.data);
	// 		} else {
	// 			throw new Error(response.data.message || "Failed to fetch checkout summary");
	// 		}
	// 	} catch (err) {
	// 		console.error("Error fetching checkout summary:", err);
	// 		const errorMsg = err.response?.data?.message || err.response?.data?.message || "Failed to load checkout details";
	// 		setError(errorMsg);
	// 		toast.error(errorMsg);
	// 		setCheckoutSummary(null);
	// 	} finally {
	// 		setIsLoadingCheckout(false);
	// 	}
	// };

	useEffect(() => {
		if (step === 1) {
			fetchAddresses();
		}
		// eslint-disable-next-line
	}, [step]);

	// useEffect(() => {
	// 	if (step === 2 && selectedAddressId) {
	// 		fetchCheckoutSummary();
	// 	}
	// 	// eslint-disable-next-line
	// }, [step, selectedAddressId]);

	const fetchUser = async () => {
		const token = Cookies.get("ecom_user_token");
		try {
			const response = await axios.get(
				`${process.env.REACT_APP_BACKEND_URL}/api/buyer/get-by-id`,
				{
					headers: {
						Authorization: `Bearer ${token}`
					}
				}
			);

			setFormData((prev) => ({ ...prev, email: (response?.data?.user?.email || "") }))
		} catch (err) {
			console.error("Error fetching user details:", err);
		} finally {
			setIsLoadingAddresses(false);
		}
	}

	useEffect(() => {
		if (orderSuccess || step != 1) return;
		
		fetchUser();

	}, [step, orderSuccess])

	const handleChange = (e) => {
		const { name, value, type, checked } = e.target;
		setFormData(prev => ({
			...prev, [name]: type === "checkbox" ? checked : value
		}));
	};

	const handleAddressSubmit = async (e) => {
		e.preventDefault();
		setError("");
		setIsSubmitting(true);

		const token = Cookies.get("ecom_user_token");
		try {
			const response = await axios.post(
				`${process.env.REACT_APP_BACKEND_URL}/api/buyer/add-shipping-address`,
				formData,
				{
					headers: {
						Authorization: `Bearer ${token}`,
						"Content-Type": "application/json"
					}
				}
			);
			if (response.status === 201) {
				const updatedAddresses = response.data.shippingAddresses || [];
				if (!Array.isArray(updatedAddresses)) {
					throw new Error("Invalid address data received");
				}
				const newAddress = updatedAddresses.reduce((latest, current) => {
					if (!latest) return current;
					return new Date(current.createdAt) > new Date(latest.createdAt) ? current : latest;
				}, null);
				if (!newAddress || !newAddress._id) throw new Error("New address not found in response");
				setAddresses(updatedAddresses);
				setSelectedAddressId(newAddress._id);
				setShowAddressForm(false);
				setFormData({
					fullName: "",
					phone: "",
					addressLine1: "",
					addressLine2: "",
					city: "",
					state: "",
					zipCode: "",
					country: "India",
					isDefault: false
				});
				toast.success(response.data.msg || "Address saved successfully!");
			}
		} catch (err) {
			console.error("Address save error:", { error: err, response: err.response?.data });
			const errorMsg = err.response?.data?.msg ||
				err.response?.data?.message || err.message || "Could not save address. Please try again.";
			setError(errorMsg);
			toast.error(errorMsg);
		} finally {
			setIsSubmitting(false);
		}
	};

	const handlePaymentSubmit = async (e) => {
		e.preventDefault();
		setIsSubmitting(true);
		setError("");

		if (!selectedAddressId) {
			setError("Please select a shipping address");
			toast.error("Please select a shipping address");
			setIsSubmitting(false);
			return;
		}

		// Don't proceed if there's an error or checkout summary is still loading
		if (error || isLoadingCheckout) {
			setIsSubmitting(false);
			return;
		}

		try {
			if (paymentMethod === "cod") {
				await handlePlaceOrder();
			} else {
				await handleRazorpayPayment();
			}
		} catch (err) {
			console.error("Payment error:", err);
			const errorMsg = err.message || "An error occurred during payment processing";
			setError(errorMsg);
			toast.error(errorMsg);
			setIsSubmitting(false);
		}
	};

	const handlePlaceOrder = async () => {
		const token = Cookies.get("ecom_user_token");
		try {
			const requestBody = {
				shippingAddressId: selectedAddressId,
				paymentMethod: paymentMethod,
				shippingCost: orderSummary.shippingCharges
			};
			const response = await axios.post(
				`${process.env.REACT_APP_BACKEND_URL}/api/order/create-order`,
				requestBody,
				{
					headers: {
						Authorization: `Bearer ${token}`,
						"Content-Type": "application/json"
					}
				}
			);
			if (response.status === 201) {
				setAmount(response?.data?.razorpayOrder?.amount);
				setOrderSuccess(true);
				setPlacedOrder(response.data.order);
				clearCart();
				fetchCart();
			} else {
				throw new Error(response.data.message || "Failed to place order");
			}
		} catch (err) {
			toast.error(err.message || "Failed to place order");
			throw err;
		} finally {
			setIsSubmitting(false);
		}
	};

	const handleRazorpayPayment = async () => {
		const token = Cookies.get("ecom_user_token");
		const currency = "INR";
		try {
			const requestBody = {
				shippingAddressId: selectedAddressId,
				paymentMethod: "razorpay",
				// shippingCost: orderSummary.shippingCharges
			};
			const orderResponse = await axios.post(
				`${process.env.REACT_APP_BACKEND_URL}/api/order/create-order`,
				requestBody,
				{
					headers: {
						Authorization: `Bearer ${token}`,
						"Content-Type": "application/json"
					}
				}
			);
			const orderId = orderResponse?.data?.order?._id;
			const razorpayOrderId = orderResponse?.data?.razorpayOrder?.id;
			setAmount(orderResponse?.data?.razorpayOrder?.amount / 100);
			await loadRazorpay();
			const options = {
				key: process.env.REACT_APP_RAZORPAY_KEY_ID,
				amount: orderResponse?.data?.razorpayOrder?.amount,
				currency,
				name: "Zakkuu",
				description: "Order Payment",
				order_id: razorpayOrderId,
				handler: async function (response) {
					try {
						const verificationResponse = await axios.post(
							`${process.env.REACT_APP_BACKEND_URL}/api/order/verify-payment`,
							{
								razorpay_order_id: response.razorpay_order_id,
								razorpay_signature: response.razorpay_signature,
								razorpay_payment_id: response.razorpay_payment_id,
								paymentId: orderResponse.data.paymentId,
							},
							{
								headers: {
									Authorization: `Bearer ${token}`,
									"Content-Type": "application/json"
								}
							}
						);
						if (verificationResponse?.status === 200) {
							setOrderSuccess(true);
							setPlacedOrder(verificationResponse.data.order);
							clearCart();
							fetchCart();
						} else {
							const errorMsg = verificationResponse.data.message || "Payment verification failed";
							setError(errorMsg);
							toast.error(errorMsg);
							fetchCart();
						}
					} catch (err) {
						console.error("Error verifying payment:", err);
						const errorMsg = err.response?.data?.message || "An error occurred while verifying payment";
						setError(errorMsg);
						toast.error(errorMsg);
						fetchCart();
					} finally {
						setIsSubmitting(false);
					}
				},
				prefill: {
					name: user?.name || "",
					email: user?.email || "",
					contact: user?.phone || "9999999999"
				},
				theme: { color: "#3399cc" },
				modal: {
					ondismiss: function () {
						toast.info("Payment window closed");
						fetchCart();
						setIsSubmitting(false);
					}
				}
			};
			const rzp = new window.Razorpay(options);
			rzp.on('payment.failed', function (response) {
				toast.error(`Payment failed: ${response.error.description}`);
				fetchCart();
				setIsSubmitting(false);
			});
			rzp.open();
		} catch (err) {
			console.error("Error in Razorpay payment:", err);
			const errorMsg = err.response?.data?.message || "An error occurred while processing payment";
			setError(errorMsg);
			toast.error(errorMsg);
			fetchCart();
			setIsSubmitting(false);
		}
	};

	const formatAddress = (address) => {
		if (!address) return "";
		return [
			address.fullName,
			address.phone,
			address.addressLine1,
			address.addressLine2,
			`${address.city}, ${address.state} ${address.zipCode}`,
			address.country
		].filter(Boolean).join(", ");
	};

	const handleBackToAddress = () => {
		setStep(1);
		setShowAddressForm(false);
		// setCheckoutSummary(null);
		if (step === 2) {
			setFormData({
				fullName: "",
				phone: "",
				addressLine1: "",
				addressLine2: "",
				city: "",
				state: "",
				zipCode: "",
				country: "India",
				isDefault: false
			});
		}
	};

	const handleGoToOrders = () => {
		setOrderSuccess(false);
		onClose();
		navigate("/profile/orders");
	};

	const handleSuccessClose = () => {
		setOrderSuccess(false);
		onClose();
	};

	const handlePaymentMethodChange = async (method) => {
		setPaymentMethod(method);
		// if (selectedAddressId) {
		// 	await fetchCheckoutSummary(method);
		// }
	};
	const isCompleteOrderDisabled = isSubmitting || isLoadingCheckout || error;

	return (
		<>
			{orderSuccess && placedOrder && (
				<OrderSuccessModal
					order={placedOrder}
					onClose={handleSuccessClose}
					onGoToOrders={handleGoToOrders}
				/>
			)}
			{!orderSuccess && (
				<div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
					<div className={`bg-white rounded-xl shadow-xl w-full max-w-2xl overflow-hidden ${step === 1 && !showAddressForm ? 'max-h-[90vh]' : ''
						}`}>
						<div className="bg-gradient-to-r from-blue-500 to-indigo-600 p-4 text-white">
							<div className="flex justify-between items-start">
								<div>
									<h2 className="text-xl font-bold flex items-center gap-2">
										{step === 1 ? (
											showAddressForm ? (
												<>
													<FiMapPin /> Add Address
												</>
											) : (
												<>
													<FiHome /> Shipping Address
												</>
											)
										) : (
											<>
												<FiUser /> Payment Method
											</>
										)}
									</h2>
									{step === 1 && showAddressForm && (
										<p className="mt-1 text-sm black-gray-600">
											Ground floor delivery is <strong>free</strong>.
											From <strong>first to second floor</strong>, delivery charges are
											<strong className="text-black-800"> ₹200 per person</strong>.
											Above <strong>second floor</strong>, delivery charges are
											<strong className="text-black-800"> ₹500 per person</strong>.
										</p>
									)}
								</div>

								<button
									onClick={onClose}
									className="text-white hover:text-gray-200 text-2xl"
									type="button"
								>
									&times;
								</button>
							</div>
						</div>
						<div className="p-6 overflow-y-auto max-h-[80vh]">
							{error && (
								<div className="mb-4 p-3 bg-red-50 text-red-700 rounded-lg text-sm border border-red-200">
									{error}
								</div>
							)}
							{step === 1 ? (
								showAddressForm ? (
									<form onSubmit={handleAddressSubmit}>
										<div className="space-y-4">
											<div className="relative">
												<label className="block text-sm font-medium text-gray-700 mb-1 pl-1">
													Full Name*
												</label>
												<div className="relative">
													<FiUser className="absolute left-3 top-3 text-gray-400" />
													<input
														type="text"
														name="fullName"
														value={formData.fullName}
														onChange={handleChange}
														required
														className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
														placeholder="John Doe"
													/>
												</div>
											</div>
											<div className="relative">
												<label className="block text-sm font-medium text-gray-700 mb-1 pl-1">
													Phone Number*
												</label>
												<div className="relative">
													<FiPhone className="absolute left-3 top-3 text-gray-400" />
													<input
														type="tel"
														name="phone"
														value={formData.phone}
														onChange={handleChange}
														required
														className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
														placeholder="Phone number"
														pattern="[0-9]{10}"
														maxLength="10"
													/>
												</div>
											</div>
											<div className="relative">
												<label className="block text-sm font-medium text-gray-700 mb-1 pl-1">
													Email*
												</label>
												<div className="relative">
													<MdOutlineMail className="absolute left-3 top-3 text-gray-400" />
													<input
														type="email"
														name="email"
														value={formData.email}
														onChange={handleChange}
														required
														className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
														placeholder="Email"
													/>
												</div>
											</div>
											<div className="relative">
												<label className="block text-sm font-medium text-gray-700 mb-1 pl-1">
													Complete Address along with Flat Number
												</label>
												<div className="relative">
													<FiMapPin className="absolute left-3 top-3 text-gray-400" />
													<input
														type="text"
														name="addressLine1"
														value={formData.addressLine1}
														onChange={handleChange}
														required
														className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
														placeholder="Complete Address along with Flat Number, Floor number"
													/>
												</div>
											</div>
											<div>
												<label className="block text-sm font-medium text-gray-700 mb-1 pl-1">
													Mention Your lift size and capacity
												</label>
												<input
													type="text"
													name="addressLine2"
													value={formData.addressLine2}
													onChange={handleChange}
													className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
													placeholder="Capcity, Car size, door width"
												/>
											</div>
											<div className="grid grid-cols-1 md:grid-cols-2 gap-4">
												<div>
													<label className="block text-sm font-medium text-gray-700 mb-1 pl-1">
														City*
													</label>
													<input
														type="text"
														name="city"
														value={formData.city}
														onChange={handleChange}
														required
														className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
														placeholder="City"
													/>
												</div>
												<div>
													<label className="block text-sm font-medium text-gray-700 mb-1 pl-1">
														State*
													</label>
													<input
														type="text"
														name="state"
														value={formData.state}
														onChange={handleChange}
														required
														className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
														placeholder="State"
													/>
												</div>
											</div>
											<div className="grid grid-cols-1 md:grid-cols-2 gap-4">
												<div>
													<label className="block text-sm font-medium text-gray-700 mb-1 pl-1">
														ZIP Code*
													</label>
													<input
														type="text"
														name="zipCode"
														value={formData.zipCode}
														onChange={handleChange}
														required
														className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
														placeholder="Postal code"
													/>
												</div>
												<div>
													<label className="block text-sm font-medium text-gray-700 mb-1 pl-1">
														Country*
													</label>
													<input
														type="text"
														name="country"
														value={formData.country}
														onChange={handleChange}
														required
														className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
														placeholder="Country"
													/>
												</div>
											</div>
											<div className="flex items-center">
												<input
													type="checkbox"
													id="isDefault"
													name="isDefault"
													checked={formData.isDefault}
													onChange={handleChange}
													className="h-5 w-5 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
												/>
												<label htmlFor="isDefault" className="ml-2 block text-sm text-gray-700">
													Set as default shipping address
												</label>
											</div>
										</div>
										<div className="mt-6 flex justify-end space-x-3">
											<button
												type="button"
												onClick={() => setShowAddressForm(false)}
												className="px-4 py-2 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-50 flex items-center"
												disabled={isSubmitting}
											>
												<FiArrowLeft className="mr-1" /> Back
											</button>
											<button
												type="submit"
												className="px-4 py-2 bg-gradient-to-r from-blue-500 to-indigo-600 text-white rounded-lg text-sm font-medium hover:opacity-90 transition-opacity focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 flex items-center"
												disabled={isSubmitting}
											>
												{isSubmitting ? "Saving..." : "Save Address"}
											</button>
										</div>
									</form>
								) : (
									<div>
										<h3 className="text-lg font-medium mb-4 flex items-center gap-2">
											<FiMapPin /> Select Shipping Address
										</h3>
										{isLoadingAddresses ? (
											<div className="flex justify-center py-8">
												<div className="animate-spin rounded-full h-10 w-10 border-t-2 border-b-2 border-blue-500"></div>
											</div>
										) : addresses.length === 0 ? (
											<div className="text-center py-8 border-2 border-dashed rounded-xl mb-4">
												<FiMapPin className="mx-auto text-3xl text-gray-400 mb-3" />
												<p className="text-gray-600 mb-4">No saved addresses found</p>
												<button
													onClick={() => setShowAddressForm(true)}
													className="px-4 py-2 bg-gradient-to-r from-blue-500 to-indigo-600 text-white rounded-lg hover:opacity-90 transition-opacity flex items-center mx-auto"
												>
													<FiPlus className="mr-1" /> Add New Address
												</button>
											</div>
										) : (
											<>
												<div className="mb-4 max-h-[50vh] overflow-y-auto pr-2">
													<div className="grid grid-cols-1 gap-3">
														{addresses.map(address => (
															<div
																key={address._id}
																className={`p-4 border rounded-xl cursor-pointer transition-all duration-200 hover:shadow-md ${selectedAddressId === address._id
																	? 'border-blue-500 border-2 bg-blue-50 shadow-sm'
																	: 'border-gray-200 hover:border-gray-300'
																	}`}
																onClick={() => setSelectedAddressId(address._id)}
															>
																<div className="flex">
																	<div className={`mr-3 mt-1 flex-shrink-0 ${selectedAddressId === address._id
																		? 'text-blue-500'
																		: 'text-gray-400'
																		}`}>
																		{selectedAddressId === address._id ? (
																			<FiCheck className="text-xl" />
																		) : (
																			<div className="w-5 h-5 rounded-full border border-gray-300"></div>
																		)}
																	</div>
																	<div className="flex-1 min-w-0">
																		{address.fullName && (
																			<p className="font-medium text-gray-800 truncate">{address.fullName}</p>
																		)}
																		<p className="text-sm text-gray-600 mt-1 break-words whitespace-pre-wrap">
																			{formatAddress(address)}
																		</p>
																		{address.isDefault && (
																			<span className="inline-block mt-2 px-2 py-1 text-xs bg-green-100 text-green-800 rounded-full">
																				Default
																			</span>
																		)}
																	</div>
																</div>
															</div>
														))}
													</div>
												</div>
												<div className="flex flex-col sm:flex-row gap-3">
													<button
														onClick={() => setShowAddressForm(true)}
														className="px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors flex items-center justify-center gap-2 flex-1"
													>
														<FiPlus /> Add New Address
													</button>
													<button
														onClick={() => setStep(2)}
														className={`px-4 py-2 rounded-lg flex items-center justify-center gap-2 flex-1 ${selectedAddressId
															? 'bg-gradient-to-r from-blue-500 to-indigo-600 text-white hover:opacity-90'
															: 'bg-gray-300 text-gray-500 cursor-not-allowed'
															}`}
														disabled={!selectedAddressId}
													>
														Continue to Payment <FiArrowLeft className="transform rotate-180" />
													</button>
												</div>
											</>
										)}
									</div>
								)
							) : (
								<form onSubmit={handlePaymentSubmit}>
									<div className="space-y-6">
										<div>
											<h3 className="text-lg font-medium mb-3 flex items-center gap-2">
												<FiUser /> Select Payment Method
											</h3>
											<div className="space-y-3">
												<label className={`flex items-center p-4 border rounded-xl transition-all ${paymentMethod === "cod"
													? 'border-blue-500 bg-blue-50 shadow-sm'
													: 'border-gray-200 hover:border-blue-300'
													}`}>
													<input
														type="radio"
														name="paymentMethod"
														value="cod"
														checked={paymentMethod === "cod"}
														onChange={() => handlePaymentMethodChange("cod")}
														className="h-5 w-5 text-blue-600 focus:ring-blue-500"
													/>
													<div className="ml-3">
														<span className="block font-medium">Cash on Delivery</span>
														<span className="block text-sm text-gray-500 mt-1">Pay when you receive your order</span>
													</div>
												</label>
												<label className={`flex items-center p-4 border rounded-xl transition-all ${paymentMethod === "razorpay"
													? 'border-blue-500 bg-blue-50 shadow-sm'
													: 'border-gray-200 hover:border-blue-300'
													}`}>
													<input
														type="radio"
														name="paymentMethod"
														value="razorpay"
														checked={paymentMethod === "razorpay"}
														onChange={() => handlePaymentMethodChange("razorpay")}
														className="h-5 w-5 text-blue-600 focus:ring-blue-500"
													/>
													<div className="ml-3">
														<span className="block font-medium">Pay with Razorpay</span>
														<span className="block text-sm text-gray-500 mt-1">Secure online payment</span>
													</div>
												</label>
											</div>
										</div>

										{/* {isLoadingCheckout ? (
											<div className="flex justify-center py-8">
												<div className="animate-spin rounded-full h-10 w-10 border-t-2 border-b-2 border-blue-500"></div>
											</div>
										) : checkoutSummary && !error ? (
											<div className="pt-4 border-t border-gray-200">
												<h3 className="text-lg font-medium mb-3">Order Summary</h3>
												<div className="space-y-2 text-sm bg-gray-50 p-4 rounded-lg">
													<div className="flex justify-between">
														<span className="text-gray-600">Subtotal:</span>
														<span className="font-medium">₹{checkoutSummary.summary.subtotal?.toFixed(2)}</span>
													</div>
													{checkoutSummary.summary.taxes > 0 && (
														<div className="flex justify-between">
															<span className="text-gray-600">Taxes:</span>
															<span className="font-medium">₹{checkoutSummary.summary.taxes?.toFixed(2)}</span>
														</div>
													)}
													<div className="flex justify-between">
														<span className="text-gray-600">Shipping:</span>
														<span className="font-medium">₹{checkoutSummary.summary.shipping?.toFixed(2)}</span>
													</div>
													{checkoutSummary.summary.codCharge > 0 && (
														<div className="flex justify-between">
															<span className="text-gray-600">COD Charges:</span>
															<span className="font-medium">₹{checkoutSummary.summary.codCharge?.toFixed(2)}</span>
														</div>
													)}
													<div className="flex justify-between font-medium pt-3 mt-2 border-t border-gray-200">
														<span className="text-gray-800">Total:</span>
														<span className="text-lg text-blue-600">₹{checkoutSummary.summary.totalAmount?.toFixed(2)}</span>
													</div>
												</div>
											</div>
										) : null} */}
									</div>
									<div className="mt-6 flex flex-col-reverse sm:flex-row justify-between gap-3">
										<button
											type="button"
											onClick={handleBackToAddress}
											className="px-4 py-2 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-50 flex items-center justify-center gap-2"
											disabled={isSubmitting}
										>
											<FiArrowLeft /> Back to Address
										</button>
										<button
											type="submit"
											className={`px-4 py-2 text-white rounded-lg text-sm font-medium transition-opacity flex items-center justify-center gap-2 ${isCompleteOrderDisabled
												? 'bg-gray-400 cursor-not-allowed'
												: 'bg-gradient-to-r from-green-500 to-emerald-600 hover:opacity-90'
												}`}
											disabled={isCompleteOrderDisabled}
										>
											{isSubmitting ? (
												<>
													<span className="animate-spin rounded-full h-4 w-4 border-t-2 border-b-2 border-white"></span>
													Processing...
												</>
											) : isLoadingCheckout ? (
												<>
													<span className="animate-spin rounded-full h-4 w-4 border-t-2 border-b-2 border-white"></span>
													Loading...
												</>
											) : (
												"Complete Order"
											)}
										</button>
									</div>
								</form>
							)}
						</div>
					</div>
				</div>
			)}
		</>
	);
};

export default ShippingAddress;
